import { c as _c } from "react/compiler-runtime";
import React from "react";
interface HomeIconProps {
  size?: number;
  className?: string;
}
const HomeIcon = t0 => {
  const $ = _c(6);
  const {
    size: t1,
    className
  } = t0;
  const size = t1 === undefined ? 24 : t1;
  const t2 = `dynamic-size ${className}`;
  let t3;
  if ($[0] !== size) {
    t3 = {
      "--width": size,
      "--height": size
    };
    $[0] = size;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const t4 = t3 as React.CSSProperties;
  let t5;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <path d="M13.0996 15C13.0996 14.9641 13.0946 14.9494 13.0938 14.9473C13.0933 14.9461 13.0923 14.9447 13.0908 14.9424C13.0892 14.9399 13.0854 14.934 13.0771 14.9258C13.0684 14.917 13.0616 14.9121 13.0586 14.9102C13.0561 14.9085 13.0542 14.9079 13.0527 14.9072L12.998 14.9004H11C10.9641 14.9004 10.9494 14.9054 10.9473 14.9062C10.9461 14.9067 10.9447 14.9077 10.9424 14.9092C10.9399 14.9108 10.934 14.9146 10.9258 14.9229C10.917 14.9316 10.9121 14.9384 10.9102 14.9414C10.9085 14.9439 10.9079 14.9458 10.9072 14.9473C10.9066 14.9488 10.9005 14.9637 10.9004 15.002V20C10.9004 20.5105 10.7174 20.9808 10.3486 21.3496C9.98024 21.718 9.51031 21.9001 9 21.8994L6 21.9004C5.20964 21.9004 4.5101 21.6087 3.95117 21.0498C3.39228 20.4909 3.10057 19.7913 3.09961 19.001V10C3.09961 9.54321 3.20353 9.10468 3.4082 8.69629C3.61109 8.29157 3.89631 7.94859 4.25977 7.67969L10.2598 3.17969V3.18066C10.7692 2.79419 11.3598 2.59961 12 2.59961C12.6399 2.59961 13.23 2.7945 13.7393 3.18066L19.7324 7.67383L19.8662 7.7793C20.1704 8.03145 20.4139 8.3395 20.5928 8.69629C20.7975 9.10469 20.9011 9.54325 20.9004 10V19C20.9004 19.7908 20.6081 20.4905 20.0488 21.0498C19.4898 21.6089 18.7904 21.9001 18 21.8994L15 21.9004C14.4896 21.9004 14.0189 21.7174 13.6504 21.3477C13.2836 20.9796 13.1008 20.5107 13.0996 20.002V15ZM4.90039 18.999L4.90527 19.1123C4.92776 19.3703 5.02879 19.5805 5.22461 19.7764C5.44834 20.0001 5.69036 20.0996 6 20.0996H9.00195C9.03943 20.0997 9.05338 20.0939 9.05371 20.0938C9.05476 20.0933 9.05628 20.0924 9.05859 20.0908C9.06131 20.089 9.06678 20.0846 9.0752 20.0762C9.08386 20.0675 9.08898 20.0623 9.09082 20.0596C9.09258 20.0569 9.0932 20.0551 9.09375 20.0537C9.09431 20.0523 9.09961 20.0377 9.09961 20V14.998C9.10081 14.4893 9.28364 14.0204 9.65039 13.6523C10.0189 13.2826 10.4896 13.0996 11 13.0996H13.002C13.5107 13.1008 13.9796 13.2836 14.3477 13.6504C14.7174 14.0189 14.9004 14.4896 14.9004 15V19.998L14.9072 20.0527C14.9079 20.0542 14.9085 20.0561 14.9102 20.0586C14.9121 20.0616 14.917 20.0684 14.9258 20.0771C14.934 20.0854 14.9399 20.0892 14.9424 20.0908C14.9447 20.0923 14.9461 20.0933 14.9473 20.0938C14.9494 20.0946 14.9641 20.0996 15 20.0996H18.001C18.3088 20.1 18.5507 20.0011 18.7754 19.7764C19.0001 19.5516 19.0996 19.3092 19.0996 19V9.99805C19.1 9.82217 19.0624 9.66061 18.9834 9.50293C18.9039 9.34444 18.8001 9.22291 18.668 9.12598L12.6602 4.62012L12.6543 4.61621C12.4648 4.47187 12.2578 4.40039 12 4.40039C11.7422 4.40039 11.5352 4.47187 11.3457 4.61621L11.3398 4.62012L5.33984 9.12012L5.33301 9.125C5.20125 9.22189 5.09738 9.3438 5.01758 9.50293C4.93826 9.6612 4.90039 9.82346 4.90039 10V18.999Z" />;
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  let t6;
  if ($[3] !== t2 || $[4] !== t4) {
    t6 = <svg className={t2} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style={t4}>{t5}</svg>;
    $[3] = t2;
    $[4] = t4;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  return t6;
};
export default HomeIcon;